export const GET_TRANSACTION = 'RPT_APPLICATION/get_transaction';
export const APPROVE_TRANSACTION = 'RPT_APPLICATION/approve_transaction';
export const UPDATE_TRANSACTION = 'RPT_APPLICATION/update_transaction';
export const SHOW_TRANSACTION = 'RPT_APPLICATION/show_transaction';
export const START_ASSESSMENT = 'RPT_APPLICATION/start_assessment';
export const GET_SETTINGS = 'RPT_APPLICATION/get_settings';
export const UPDATE_TEST_STATUS = 'RPT_APPLICATION/update_health_status';
export const ASSESS_RECEIPT = 'BIRTH_CERTIFICATES/assess_receipt';
export const RPTAX_ESOA_URL =
  'api/v1/administrators/transaction_histories/real_property_taxes/{id}/preview_soa';
export const RPTAX_EOR_URL =
  'api/v1/administrators/transaction_histories/real_property_taxes/{id}/preview_or';

export const OCCUPATIONAL_PERMIT_URI =
  'api/v1/administrators/occupational_permit/';
export const HEALTH_CERTIFICATE_URI =
  'api/v1/administrators/health_certificate/';

  // for smartcity/pldt
  export const GET_TRANSACTION_SMART_CITY = 'RPT_APPLICATION_SMART_CITY/get_transaction_smart_city';
  export const SHOW_TRANSACTION_SMART_CITY = 'SHOW_TRANSACTION_SMART_CITY/show_transaction_smart_city'

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};
